export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9104.e38e6327.jpg";